<div fxLayout="column" fxLayout.xs="column" fxLayoutGap="20px" fxLayoutAlign="left top">
    <app-input fxFlex="100%;" (keydown.enter)="emitClick($event)" (valueEmit)="emitValue($event)" [option]="options.input"></app-input>
    <div style="position: relative;">
        <app-button (clickEvent)="emitClick($event)" [btnOption]="options.button" [disabled]="inputLoading || disabled" class="login-btn"></app-button>
        <div class="button-row">
            <ng-container *cidComponentLoader="inputLoading"></ng-container>
        </div>
    </div>
</div>
